/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FusionMelcoFusionModelsFusionAppSetting,
    FusionMelcoFusionModelsFusionAppSettingFromJSON,
    FusionMelcoFusionModelsFusionAppSettingToJSON,
    FusionMelcoFusionModelsFusionConfiguratorSetting,
    FusionMelcoFusionModelsFusionConfiguratorSettingFromJSON,
    FusionMelcoFusionModelsFusionConfiguratorSettingToJSON,
    FusionMelcoModelsDefaultAppSetting,
    FusionMelcoModelsDefaultAppSettingFromJSON,
    FusionMelcoModelsDefaultAppSettingToJSON,
    FusionMelcoModelsError,
    FusionMelcoModelsErrorFromJSON,
    FusionMelcoModelsErrorToJSON,
} from '../models';

export interface FusionSettingsApiSettingsEditFusionAppSettingRequest {
    fusionMelcoFusionModelsFusionAppSetting?: FusionMelcoFusionModelsFusionAppSetting;
}

export interface FusionSettingsApiSettingsEditFusionConfiguratorSettingRequest {
    fusionMelcoFusionModelsFusionConfiguratorSetting?: FusionMelcoFusionModelsFusionConfiguratorSetting;
}

/**
 * 
 */
export class FusionSettingsApi extends runtime.BaseAPI {

    /**
     */
    async settingsDeleteFusionAppSettingRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fusion/settings/app`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async settingsDeleteFusionAppSetting(): Promise<void> {
        await this.settingsDeleteFusionAppSettingRaw();
    }

    /**
     */
    async settingsDeleteFusionConfiguratorSettingRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fusion/settings/configurator`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async settingsDeleteFusionConfiguratorSetting(): Promise<void> {
        await this.settingsDeleteFusionConfiguratorSettingRaw();
    }

    /**
     */
    async settingsEditFusionAppSettingRaw(requestParameters: FusionSettingsApiSettingsEditFusionAppSettingRequest): Promise<runtime.ApiResponse<FusionMelcoFusionModelsFusionAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/fusion/settings/app`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FusionMelcoFusionModelsFusionAppSettingToJSON(requestParameters.fusionMelcoFusionModelsFusionAppSetting),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FusionMelcoFusionModelsFusionAppSettingFromJSON(jsonValue));
    }

    /**
     */
    async settingsEditFusionAppSetting(requestParameters: FusionSettingsApiSettingsEditFusionAppSettingRequest): Promise<FusionMelcoFusionModelsFusionAppSetting> {
        const response = await this.settingsEditFusionAppSettingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async settingsEditFusionConfiguratorSettingRaw(requestParameters: FusionSettingsApiSettingsEditFusionConfiguratorSettingRequest): Promise<runtime.ApiResponse<FusionMelcoFusionModelsFusionConfiguratorSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/fusion/settings/configurator`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FusionMelcoFusionModelsFusionConfiguratorSettingToJSON(requestParameters.fusionMelcoFusionModelsFusionConfiguratorSetting),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FusionMelcoFusionModelsFusionConfiguratorSettingFromJSON(jsonValue));
    }

    /**
     */
    async settingsEditFusionConfiguratorSetting(requestParameters: FusionSettingsApiSettingsEditFusionConfiguratorSettingRequest): Promise<FusionMelcoFusionModelsFusionConfiguratorSetting> {
        const response = await this.settingsEditFusionConfiguratorSettingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async settingsGetFusionAppSettingRaw(): Promise<runtime.ApiResponse<FusionMelcoFusionModelsFusionAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fusion/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FusionMelcoFusionModelsFusionAppSettingFromJSON(jsonValue));
    }

    /**
     */
    async settingsGetFusionAppSetting(): Promise<FusionMelcoFusionModelsFusionAppSetting> {
        const response = await this.settingsGetFusionAppSettingRaw();
        return await response.value();
    }

    /**
     */
    async settingsGetFusionConfiguratorSettingRaw(): Promise<runtime.ApiResponse<FusionMelcoFusionModelsFusionConfiguratorSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fusion/settings/configurator`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FusionMelcoFusionModelsFusionConfiguratorSettingFromJSON(jsonValue));
    }

    /**
     */
    async settingsGetFusionConfiguratorSetting(): Promise<FusionMelcoFusionModelsFusionConfiguratorSetting> {
        const response = await this.settingsGetFusionConfiguratorSettingRaw();
        return await response.value();
    }

    /**
     */
    async settingsGetFusionDefaultSettingRaw(): Promise<runtime.ApiResponse<FusionMelcoModelsDefaultAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fusion/defaults/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FusionMelcoModelsDefaultAppSettingFromJSON(jsonValue));
    }

    /**
     */
    async settingsGetFusionDefaultSetting(): Promise<FusionMelcoModelsDefaultAppSetting> {
        const response = await this.settingsGetFusionDefaultSettingRaw();
        return await response.value();
    }

}
